import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, UncontrolledTooltip} from "reactstrap";
import QSignPracovnikApi from "../../api/gen/qsign/QSignPracovnikApi";
import {Loader, modal} from "@mc/mc-legacy";
import CreateApproversForm from "../forms/CreateApproversForm";

class ApprovalField extends Component {

    handleChangeApprovers = (value) => {
        const {dispatch, onChange} = this.props;
        dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání nastavení schvalování",
                <Loader/>,
                QSignPracovnikApi.findAllActive(),
                (pracovnici) => {
                    const pracovniciTransform = pracovnici.map(item => {
                        return ({
                            id: item.id,
                            name: `${item.uplneJmeno} ${item.organizacniJednotka ? `(${item.organizacniJednotka.kod})` : ""}`,
                            title: item.organizacniJednotka.nazev,
                        });
                    });

                    dispatch(
                        modal.ModalActions.show(
                            CreateApproversForm,
                            {
                                onSubmit: (data) => {
                                    onChange(data);
                                    //return signRequestInternalApi.changeApproval(signRequest.id, data);
                                },
                                onSubmitSuccess: (result, dispatch) => {
                                    dispatch(modal.ModalActions.hide());
                                },
                                initialValues: {
                                    steps: value?.steps || [{name: "Krok č. 1", everyone: false, approvers: [{pracovnikId: null, flowId: null}]}]
                                },
                                pracovnici: pracovniciTransform,
                            },
                            "Nastavení schvalování"
                        )
                    );
                }
            )
        );
    };

    render() {
        const {value, onChange, dispatch, disabled} = this.props;
        let render = <Button type="button" disabled={disabled} onClick={() => this.handleChangeApprovers(value)}>Nastavit schvalování</Button>;
        let info;
        if (value && value.steps.length > 0) {
            let pocetSchvalujich = 0;
            value.steps.map(step => {
                pocetSchvalujich += step.approvers.length
            });
            info = <><span
                id={"approveTooltip"}>{`Nastaveno ${value.steps.length} kroků, ${pocetSchvalujich} schvalujících`}</span>
                <UncontrolledTooltip placement={"right"} target={"approveTooltip"}>
                    <span>Tlačítkem nastavit zobrazíte podrobnosti a nástroje pro příp. úpravu schvalování</span>
                </UncontrolledTooltip>
            </>

        }

        return (
            <div className="approval-field">
                {render} {info}
            </div>
        );
    }
}

export default connect((state) => {
    return {};
})(ApprovalField);
